import React from "react";
import { handleGenerateUsers } from "../api/generateContentApi";

const UserGenerator = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        margin: 30,
      }}
    >
      <h1>Generate Users</h1>
      <div style={{ margin: 10 }}>
        <label>number: </label>
        <input
          type="number"
          name="number"
          //   defaultValue={data.grade}
          //   onChange={(e) => handleGetContent(e)}
        />
      </div>
      <button onClick={() => handleGenerateUsers(1, "boy", 4)}>
        genrate users
      </button>
    </div>
  );
};

export default UserGenerator;
